import { createSlice } from "@reduxjs/toolkit";

// Single source of truth for periods
export const TIME_PERIODS = ["Daily", "Weekly", "Monthly", "Annually"];
export const DEFAULT_PERIOD = "Monthly";

const initialState = {
  strategiesByPeriod: TIME_PERIODS.reduce((acc, period) => {
    acc[period] = null;
    return acc;
  }, {}),
  currentPeriod: DEFAULT_PERIOD,
  loading: false,
  error: null
};

const strategyStoreSlice = createSlice({
  name: "strategyStore",
  initialState,
  reducers: {
    setStrategiesForPeriod: (state, action) => {
      const { period, strategies } = action.payload;
      state.strategiesByPeriod[period] = strategies;
      state.loading = false;
      state.error = null;
    },
    setStrategyStoreLoading: (state, action) => {
      state.loading = action.payload;
    },
    setStrategyStoreError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearStrategyStoreCache: (state) => {
      state.strategiesByPeriod = initialState.strategiesByPeriod;
    },
    setCurrentPeriod: (state, action) => {
      state.currentPeriod = action.payload;
    },
    switchPeriod: (state, action) => {
      const newPeriod = action.payload;
      state.currentPeriod = newPeriod;
      if (!state.strategiesByPeriod[newPeriod]) {
        state.loading = true;
      }
    }
  }
});

export const {
  setStrategiesForPeriod,
  setStrategyStoreLoading,
  setStrategyStoreError,
  clearStrategyStoreCache,
  setCurrentPeriod,
  switchPeriod
} = strategyStoreSlice.actions;

// Selectors
export const selectStrategiesForPeriod = (period) => (state) =>
  state.strategyStore.strategiesByPeriod[period];



export const selectStrategyStoreLoading = (state) => state.strategyStore.loading;
export const selectStrategyStoreError = (state) => state.strategyStore.error;
export const selectCurrentPeriod = (state) => state.strategyStore.currentPeriod;

export default strategyStoreSlice.reducer;
